import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebounced } from "@/hooks/useDebounced";
import { useUsersBySearch } from "@/hooks/users/useUsersBySearch";
import { getUserDisplayName } from "@/utilities/user/getUserDisplayName";

interface Props {
  onChange(value?: string): void;
}

export function UserSelect({ onChange }: Props) {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const searchDebounced = useDebounced(search, 300);
  const { data: users = [], isLoading: isUserLoading } = useUsersBySearch(
    searchDebounced,
    false,
    false,
    false,
  );

  return (
    <Autocomplete
      id="user-search"
      size="small"
      onChange={(_, value) => onChange(value?.id)}
      loading={isUserLoading}
      fullWidth
      options={users}
      getOptionLabel={option => getUserDisplayName(option)}
      onInputChange={(_, value) => setSearch(value)}
      filterOptions={o => o}
      filterSelectedOptions
      disableCloseOnSelect
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {getUserDisplayName(option)}
          </li>
        );
      }}
      renderInput={params => (
        <TextField
          {...params}
          label={t("logbookEdit.user")}
          placeholder={t("logbookEdit.userPlaceholder")}
        />
      )}
    />
  );
}
